<template>
  <van-popup v-model="show" round position="bottom">
    <van-number-keyboard
      :title="number"
      v-model="number"
      :show="show"
      close-button-text="完成"
      :maxlength="maxlength"
      @blur="show = false"
      @close="onConfirm"
    />
  </van-popup>
</template>

<script>
import { NumberKeyboard } from 'vant';
export default {
  name: 'NumberPicker',
  components: {
    [NumberKeyboard.name]: NumberKeyboard
  },
  props: {
    value: {
      type: String | Number
    },
    maxlength: {
      type: Number,
      default: 9
    }
  },
  
  model: {
    prop: 'value',
    event: 'update'
  },
  data() {
    return {
      show: false,
      number: ''
    }
  },
  methods: {
    open() {
      this.number = this.value ? `${this.value}` : ''
      this.show = true
    },
    onConfirm() {
      const number = this.number ? Number(this.number) : 0
      this.$emit('update', number)
      this.show = false
    }
  }
}
</script>

<style lang="less" scoped>
  .value-wrapper {
    width: 100%;
    height: 40px;
    text-align: center;
    line-height: 40px;
  }
</style>